<div *ngIf="(data$ | async) === null">
  <div>
    <span [innerHTML]="'loading top form-data'"></span>
  </div>
</div>
<div edsGrid *ngIf="data$ | async as data">
  <div class="container">
    <div edsRow>
      <div edsCol>
        <eds-title
          edsSpacing="lg"
          theme="dark"
          [isLight]="true"
          title="{{ 'literature.top-forms' | translate }}"
          [size]="'h3'"
        ></eds-title>
      </div>
    </div>
    <eds-sidebar [closeButton]="true" [divider]="false" [hasPadding]="false">
      <ng-container *ngFor="let document of data; let i = index">
        <a
          edsPadding
          edsPaddingAll="md"
          [href]="linkToNavigateDetailPage(document.docId)"
          class="sidebar__list-item sidebar__list-item--black"
          edsFlexbox
          alignItems="center"
          justifyContent="space-between"
        >
          <div edsPadding edsPaddingRight="xs">{{ document.dctermsTitle }}</div>
          <eds-icon
            class="sidebar__icon--primary"
            type="carrot-right"
            size="small"
          ></eds-icon>
        </a>
        <eds-divider *ngIf="i < data.length - 1"></eds-divider>
      </ng-container>
    </eds-sidebar>
  </div>
</div>
